import React from 'react';
import {
  Box,
  Button,
  Stack,
  Typography,
} from '@mui/material';

const EmptyState = ({
  title = 'No data available',
  description,
  action,
  icon,
  minHeight = 240,
  align = 'center',
}) => (
  <Stack
    alignItems={align === 'center' ? 'center' : 'flex-start'}
    justifyContent="center"
    spacing={1}
    sx={{
      height: minHeight,
      textAlign: align,
      color: 'text.secondary',
      px: 2,
    }}
  >
    {icon && <Box sx={{ fontSize: 32, opacity: 0.6 }}>{icon}</Box>}
    <Typography variant="body2">{title}</Typography>
    {description && (
      <Typography variant="caption" sx={{ maxWidth: 320 }}>
        {description}
      </Typography>
    )}
    {action && (
      <Button size="small" onClick={action.onClick} variant={action.variant || 'contained'}>
        {action.label}
      </Button>
    )}
  </Stack>
);

export default EmptyState;

